import Utils from "./utils";
import { SortOption } from "./models/sort.model";

export class Paging<T extends {}> {

  private page_size: number = 0;
  // private max_page: number = 0;
  private cur_page: number = 0;
  private paging_data: T[];
  private initialized_data: T[];
  private sort_option: SortOption[] | null = null;
  private filter_function: ((item: T) => boolean)[];

  /** constructor, sollte noch erweitert werden um die richtigen daten herauszu geben */
  public constructor(data: T[], pagesize: number = 5, sortOption: SortOption[] = null, filterFunction: ((item: T) => boolean)[] = null) {
    this.initialized_data = data;
    this.paging_data = this.initialized_data;
    this.page_size = pagesize;
    this.sort_option = sortOption;
    this.filter_function = filterFunction;
    this.reset(true, true);
  }

  public get Data(): T[] {
    return this.paging_data;
  }

  public get PageSize(): number {
    return this.page_size;
  }

  public get CurrentPage(): number {
    return this.cur_page;
  }

  /** gets the Items for the next page
   * @returns item array with items on next page, or empty array, when no next page there
   */
  public nextPage(): T[] {
    const me = this;

    const max_length = me.paging_data.length;
    const cur_item = me.cur_page * me.page_size;
    // brake if no next page there
    if (cur_item >= max_length) {
      return [];
    }
    // get the itemcount for this page
    let read_items = me.page_size;
    if (cur_item + read_items > max_length) {
      // the last page kan
      read_items = max_length - cur_item;
    }

    const result: T[] = [];
    // index = cur_item um den offset +1 und -1 zu sparen
    for (let i = cur_item; i < cur_item + read_items; ++i) {
      result.push(me.paging_data[i]);
    }
    me.cur_page += 1;
    return result;
  }

  /** return first objects in double pagesize and sets the current page back.
   * @param initPages loads the count of pages at the begining.
   * @returns objects in double pagesize.
   */
  public initLoad(initPages: number = 2): T[] {
    const me = this;
    if (me.cur_page !== 0) {
      me.reset(false, false);
    }

    const result: T[] = new Array();
    let nextPage: T[] = null;
    do {
      nextPage = me.nextPage();
      result.push(...nextPage);
    } while (me.cur_page < initPages && nextPage.length === me.page_size);
    return result;
  }

  /** set sort and filtr option for next page or initialLoad.
   * @param with_sort if true, sort option will be set again
   * @param with_filer if true , filter function will set again
   */
  private reset(with_sort: boolean, with_filer: boolean): void {
    const me = this;

    // filter data before pagination
    if (with_filer) {
      me.filterFunction();
    }

    // sort data before pagination
    if (with_sort) {
      me.paging_data.sort(me.fieldSorter(me.sort_option));
    }

    me.cur_page = 0;
  }

  /** sort the whole list base on property and direction.
   * @param sortObject get the sortOption from user and set sort_option.
   */
  public setSorting(sortOption: SortOption[]): void {
    const me = this;
    me.sort_option = sortOption;

    me.reset(true, false);
  }

  /** CompareFunction that used in sorting function.
   * undefined data will stand at the last of the list.
   * @param sortObject loads the list of property name and direction for sorting.
   * @result return a CompareFunction for sirting data that in user in Array.sort() or null if no sortparams
   */
  private fieldSorter(sortObject: SortOption[]): (left: T, right: T) => number {
    if (!Utils.IsNull(sortObject) && sortObject.length > 0) {
      return (left: T, right: T): number => sortObject.map(o => {
        return left[o.field] > right[o.field] ? o.direction : left[o.field] < right[o.field] ? -(o.direction) : 0;
      }).reduce((p, n) => p ? p : n, 0);
    } else {
      return null;
    }
  }

  /** get new 'filterFunction' for filtering data from user. set the 'filter_Function' of paging class by User FilterFunction.
   * @param filterFunction include a list of 'function' filter paging data.
   */
  public setFilter(filterFunction: ((item: T) => boolean)[] = null): void {
    const me = this;
    me.filter_function = filterFunction;
    me.paging_data = me.initialized_data; // get all data again to filter with new filter_option
    me.reset(false, true);
  }

  public getAllData(): T[] {
    return this.initialized_data;
  }

  /** filter paging_data base on filterFunction list.
   */
  private filterFunction(): void {
    const me = this;
    if (!Utils.IsNull(me.filter_function)) {
      me.filter_function.forEach(filterFunc => {
        me.paging_data = me.paging_data.filter(filterFunc);
      });
    }
  }
}
